import React, { useState } from 'react';

import './index.css';

import { Loader } from '@nw/omega-design-system';
import { Config } from '@nw/shared/config';
import { CrossIcon } from '@nw/shared/ui';

import {
  CancelButton,
  Iframe,
  IframeContainer,
  ModalContainer
} from './styledComponent';

interface CantLoginModalProps {
  isOpen: boolean;
  onCloseCantLogin: () => void;
  iframeURL?: string;
}

const CantLoginModal: React.FC<CantLoginModalProps> = ({
  isOpen,
  onCloseCantLogin,
  iframeURL
}) => {
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  const onLoadIframe = () => {
    setIsIframeLoaded(true);
  };

  const onCloseModal = () => {
    setIsIframeLoaded(false);
    onCloseCantLogin();
  };

  return (
    <ModalContainer
      isOpen={isOpen}
      onRequestClose={onCloseModal}
      contentLabel={'Cant login Modal'}
      ariaHideApp={false}
    >
      <CancelButton onClick={onCloseModal}>
        <CrossIcon />
      </CancelButton>
      <IframeContainer>
        {isIframeLoaded ? null : <Loader />}
        <Iframe
          src={iframeURL ?? Config['CANT_LOGIN_URL']}
          onLoad={onLoadIframe}
          isIframeLoaded={isIframeLoaded}
        />
      </IframeContainer>
    </ModalContainer>
  );
};

export { CantLoginModal };
